export default __webpack_public_path__ + "advantage-3419820.png";